/**
 * MCP consent — form field names and API paths aligned with Identity.
 * Confirm with Identity before release: POST encoding, policy query params, cloudId resolution.
 *
 * Server-side (Identity / resume handler): re-validate JWT, re-run policy or equivalent,
 * and ensure POSTed selectedScopes and selectedToolsets are subsets of JWT ∩ policy.
 * Do not trust the browser POST alone.
 */
export const MCP_RESUME_FORM_FIELDS = {
  /**
   * Space-delimited OAuth scope strings: union of scopes across selected toolsets, deduped.
   * The API already filters toolsets to JWT-authorized scopes — no client-side intersection needed.
   */
  selectedScopes: 'selectedScopes',
  /** Comma-separated toolset names: (policy-allowed ∩ user-selected). */
  selectedToolsets: 'selectedToolsets',
} as const;

/** Separator for multiple toolset names in the resume POST body. */
export const MCP_SELECTED_TOOLSETS_SEPARATOR = ',';

// The workspace policy API path has moved to shared/agent-consent/domain/policyClient.ts
// (WORKSPACE_POLICY_PATH). MCP-specific form fields remain here.
